import { render, staticRenderFns } from "./GiftPGA.vue?vue&type=template&id=486bf264"
import script from "./GiftPGA.vue?vue&type=script&lang=js"
export * from "./GiftPGA.vue?vue&type=script&lang=js"
import style0 from "./GiftPGA.vue?vue&type=style&index=0&id=486bf264&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports